import { z } from 'zod';

import { chapterQuerySchema } from '../chapters-selector';
import { topicQuerySchema } from '../topics-selector';

export const courseQuerySchema = z.object({
  id: z.string(),
  name: z.string(),
  question_count: z.number().nullish(),
});

export type CourseQuerySchema = z.infer<typeof courseQuerySchema>;

export const courseQueryAllSchema = z.object({ data: z.array(courseQuerySchema) });
export type CourseQueryAllSchema = z.infer<typeof courseQueryAllSchema>;

export const courseStructureQuerySchema = z.object({
  course_id: z.string(),
  course_name: z.string(),
  question_count: z.number(),
  chapters: z.array(chapterQuerySchema),
  topics: z.array(topicQuerySchema),
});

export type CourseStructureQuerySchema = z.infer<typeof courseStructureQuerySchema>;
